import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "@src/common/components";

// keeps long airbill / reference numbers from widening the table
const REFERENCE_COLUMN_MAX_WIDTH = 120;

interface OrderReferenceCellProps {
  referenceNumber: string | null | undefined;
}

export function OrderReferenceCell({
  referenceNumber,
}: OrderReferenceCellProps) {
  const referenceRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  // Measured on mount rather than on hover so the tooltip is already wrapped by
  // the time the dispatcher hovers — measuring on mouse enter only takes effect
  // on the second hover, since the pointer is already inside after the rerender.
  useEffect(() => {
    const referenceElement = referenceRef.current;
    if (!referenceElement) return;
    setIsTruncated(
      referenceElement.scrollWidth > referenceElement.clientWidth,
    );
  }, [referenceNumber]);

  if (!referenceNumber)
    return <div className="text-xs dark:text-gray-300">-</div>;

  const referenceText = (
    <div
      ref={referenceRef}
      className="text-xs truncate dark:text-gray-300"
      style={{ maxWidth: REFERENCE_COLUMN_MAX_WIDTH }}
    >
      {referenceNumber}
    </div>
  );

  if (!isTruncated) return referenceText;

  return (
    <Tooltip content={referenceNumber} placement="bottom" style="light">
      {referenceText}
    </Tooltip>
  );
}
